import { ClickAwayListener, Modal } from "@mui/material";
import useModalState from "@src/library/useModalState";
import { useState } from "react";

export function VideoMsg({ url, text }: { url: string; text: string }) {
    const [open, openModal, closeModal] = useModalState(false);

    return (
        <div className="flex flex-col items-center cursor-pointer" onClick={openModal}>
            <Modal
                className="flex flex-col justify-center items-center m-0 lg:m-80 text-center"
                open={open}
                onClose={closeModal}
                aria-labelledby="video-modal-title"
                aria-describedby="video-modal-description"
                disableScrollLock
            >
                <ClickAwayListener onClickAway={closeModal}>
                    <div className="flex flex-col items-center gap-3 bg-white p-6 border border-stone-400 rounded-2xl">
                        <video
                            className="border border-stone-300 rounded-xl max-w-[80dvw] max-h-[70dvh]"
                            src={url}
                            controls
                            autoPlay
                        />
                        {text && <span className="text-stone-600 text-sm">{text}</span>}
                    </div>
                </ClickAwayListener>
            </Modal>

            <div className="relative flex justify-center items-center bg-stone-200 border border-stone-300 rounded-xl w-40 h-40 overflow-hidden">
                <video
                    className="absolute inset-0 opacity-60 w-full h-full object-cover pointer-events-none"
                    src={url}
                    muted
                    preload="metadata"
                />
                <div className="z-10 relative bg-white/80cw: shadow p-2 rounded-full aspect-square">
                    <PlayIcon className="fill-sky-500 size-4" />
                </div>
            </div>
            {text && <span className="mt-1 text-stone-500 text-xs">{text}</span>}
        </div>
    );
}

const PlayIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
        <path d="M8 5v14l11-7z" />
    </svg>
);
